import React from 'react';
import { Link } from '@paypalcorp/pp-react';
export default ({ authEventHandler, isContentLoaded, localizedContent = () => { }, logger, csrf, csrfNonce, options = {}, publicCredential = '', }) => {
    if (!options.merchantName || !isContentLoaded) {
        return null;
    }
    return (React.createElement("div", { style: { textAlign: 'center', marginTop: '50px' } },
        React.createElement(Link, { href: "#", id: "cancelAndReturnToMerchantLink", "data-testid": "cancel-and-return-to-merchant-link", style: { fontSize: '12.8px', fontWeight: 'bold' }, onClick: (e) => {
                e.preventDefault();
                logger.track('r2m_clicked');
                logger.flush({ csrf, csrfNonce: csrf ? null : csrfNonce });
                authEventHandler({ event: 'cancelAndReturn', data: { email: publicCredential } });
            } }, localizedContent('cancelAndReturnToMerchant', { merchantName: options.merchantName }))));
};
